import { defineComponent as _defineComponent } from 'vue'
import { shallowRef, watch } from "vue"

import { getFullImagePath } from "@/utils/cdn"

type Props = {
  images: Array<string>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductGallery',
  props: {
    images: null
  },
  setup(__props: any) {

const props = __props as {
  images: Array<string>
};



const chosenImage = shallowRef<string>(props.images[0])

const onChooseImage = (image: string) => {
  chosenImage.value = image
}

watch(
  () => props.images,
  (images) => onChooseImage(images[0])
)

return { __sfc: true,props, chosenImage, onChooseImage, getFullImagePath }
}

})